import '../../componentiba/IbaAgentAllDetails/IbaAgentAllDetails.scss';
import backDetails from '../../../../asset/images/ibaimages/backDetails.svg'
import HeaderAgent from '../../commonComp/headrAgent/HeaderAgent';
import PersonalAndBank from '../../commonComp/personalAndBank/PersonalAndBank';
import IbaPayout from '../../commonComp/ibaPayout/IbaPayout';
import womenImg from '../../../../asset/images/ibaimages/womenImg.svg'
import IbaBank from '../../commonComp/IbaBankDetails/IbaBankDetails';
import TraningDetails from '../../commonComp/traningDetails/TraningDetails';
import { useEffect, useState } from 'react';
import { IBA_Admin_Section } from '../../../../Configuration/API_URL';
import { axiosInstance0 } from '../../../../CommonMethhods/axiosInstance';

const IbaAgentAllDetails = ({ setPageStatus, selectedAgent, refreshAgentList, setSelectedAgent }) => {
    console.log(selectedAgent, "selectedAgent");
    const getRole = localStorage.getItem("IbaRole");
    const [agentsDetails, setAgentsDetails] = useState({})

    const backNavigate = () => {
        setPageStatus(false)
    }

    const agentAllDetails = async () => {
        const payload = {
            sapcode: selectedAgent?.sapCode
        }
        try {
            const response = await axiosInstance0.post(
                IBA_Admin_Section.agentPersonalDetails,
                payload,

            );
            const data = await response?.data;
            if (data.status === 0) {
                setAgentsDetails(data?.data);
            } else {
                setAgentsDetails([]);
            }
        } catch (err) {
            console.log(err);
            setAgentsDetails([]);
        }
    };

    useEffect(() => {
        agentAllDetails()
    }, []);


    return (
        <div>
            <main id="main-content" className="telecallerDash">
                <div className='card-box iba-page'>
                    <div className="agent-table-wrapper">
                        <div className="wrap-header ag-detail">
                            <img style={{ cursor: "pointer" }} src={backDetails} alt="backDetails" onClick={() => backNavigate()} />
                            <div className='module-title'>Agent Details</div>
                        </div>

                        <div className='mt-4'>
                            <HeaderAgent agentsDetails={agentsDetails}
                                refreshAgentDetails={agentAllDetails}
                                selectedAgent={selectedAgent}
                                refreshAgentList={refreshAgentList} 
                                setSelectedAgent={setSelectedAgent} />

                            <div className='personal-card'>
                                <PersonalAndBank selectedAgent={agentsDetails} />
                                <IbaBank selectedAgent={agentsDetails} />
                            </div>
                            {getRole === "IBA Admin" &&
                                <IbaPayout selectedAgent={agentsDetails} />
                            }
                        </div>
                        {/* <TraningDetails selectedAgent={agentsDetails} /> */}
                    </div>
                </div>
            </main>
        </div>
    )
}

export default IbaAgentAllDetails
